import { HttpErrorResponse } from '@angular/common/http';

export type BormaDagoErrorCode =
  | 'authentication_failed'
  | 'exceeds_basket'
  | 'expired'
  | 'invalid'
  | 'not_authenticated'
  | 'not_found'
  | 'permission_denied'
  | 'recaptcha_rejected'
  | 'redeemed'
  | 'ticket_not_valid'
  | 'token_expired'
  | 'token_not_valid'
  | 'two_factor_required'
  | 'two_factor_totp_required'
  | 'two_factor_totp_throttled'
  | 'voided';

// these constants are actually too close to types, hence we put them in this file instead.
export const BORMA_DAGO_ERROR_CODE_FORM_INVALID: BormaDagoErrorCode = 'invalid';
export const BORMA_DAGO_ERROR_CODE_RECAPTCHA_REJECTED: BormaDagoErrorCode =
  'recaptcha_rejected';
export const BORMA_DAGO_ERROR_CODE_TOKEN_EXPIRED: BormaDagoErrorCode =
  'token_expired';

export interface BormaDagoError {
  detail: string;
  error_code?: BormaDagoErrorCode;
  [errorKeyword: string]: string | string[] | undefined;
}

export interface BormaDagoHttpErrorResponse extends HttpErrorResponse {
  error: BormaDagoError;
}
